import {getProfNoDeletedProfSpacsForProfGralGrid} from 'constants/url';
import axios from 'axios';

async function getProfSpacs(token) {
  try {
    const response = await axios.get(
      `${getProfNoDeletedProfSpacsForProfGralGrid}`,
      {
        headers: {Authorization: `Bearer ${token}`},
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

export default getProfSpacs;
